module.exports = __webpack_public_path__ + "img/partners10.f6457f35.png";